<template>
  <v-toolbar-items v-if="!list" class="hidden-sm-and-down">
    <v-btn v-for="item in links" flat v-if="item.visible" :key="item.name" :to="item.to">{{item.name}}</v-btn>
  </v-toolbar-items>
  <v-list v-else dense>
    <v-list-tile v-if="item.visible" v-for="item in links" :key="item.name" :to="item.to" v-tooltip="{content: mini ? item.name : null}">
      <v-list-tile-action >
        <v-icon >{{item.icon}}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content >
        <v-list-tile-title>{{item.name}}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    mini: Boolean,
    list: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isTrainer', 'isRunner', 'authUser']),
    links () {
      return [
        {visible: true, to: {name: 'packages'}, name: 'Pakiety', icon: 'bookmarks'},
        {visible: true, to: {name: 'runners-admin'}, name: 'Zawodnicy', icon: 'directions_run'},
        {visible: true, to: {name: 'trainers-admin'}, name: 'Trenerzy', icon: 'people'},
        {visible: true, to: {name: 'admin-videos'}, name: 'Filmy', icon: 'movie'},
        {visible: true, to: {name: 'pages-admin', params: {slug: 'discounts'}}, name: 'Zniżki', icon: 'card_giftcard'},
        {visible: true, to: {name: 'pages-admin', params: {slug: 'explanations'}}, name: 'Objaśnienia', icon: 'contact_support'},
        {visible: true, to: {name: 'payments-admin'}, name: 'Płatności', icon: 'attach_money'},
        {visible: true, to: {name: 'forum-admin'}, name: 'Forum', icon: 'forum'},
        {visible: this.isTrainer, to: {name: 'trainer-panel', params: {id: this.authUser.id}}, name: 'Panel trenera', icon: 'view_carousel'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/AdminNav.vue